import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CustomerReportRequest } from '../models/api/customerReport';
import { ReportVariableCategoryDto } from '../models/api/reportVariable';
import { PaginatedResponse } from '../models/paginatedResponse';
import { CustomerCompaniesSearchRequest } from '../models/api/customerCompaniesSearchRequest';
import { CustomerCompanySearchResultDto } from '../models/api/customerCompanySearchResultDto';

@Injectable({ providedIn: 'root' })
export class DataStatisticsService {
  private http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/customers/me`;

  getReportVariables(): Observable<ReportVariableCategoryDto[]> {
    return this.http.get<ReportVariableCategoryDto[]>(`${this.base}/report-variables`);
  }

  searchCustomerCompanies(request: CustomerCompaniesSearchRequest): Observable<PaginatedResponse<CustomerCompanySearchResultDto>> {
    return this.http.post<PaginatedResponse<CustomerCompanySearchResultDto>>(
      `${environment.apiUrl}/customer/companies/search`,
      request
    );
  }

  /** Every company matching the filters, capped at 50,000 server-side. */
  searchAllCustomerCompanies(request: CustomerCompaniesSearchRequest): Observable<CustomerCompanySearchResultDto[]> {
    return this.http.post<CustomerCompanySearchResultDto[]>(
      `${environment.apiUrl}/customer/companies/search/all`,
      request
    );
  }

  // The report endpoints generate the CSV server-side and return it as a file,
  // so these requests resolve to the finished blob ready for download.
  // company-report now streams from the precalculated CompanyReportCells table;
  // company-report-legacy (resolver-based) is kept on the backend for dev use.
  generateCompanyReport(request: CustomerReportRequest): Observable<Blob> {
    return this.http.post(`${this.base}/company-report`, request, { responseType: 'blob' });
  }

  generateDirectorReport(request: CustomerReportRequest): Observable<Blob> {
    return this.http.post(`${this.base}/director-report`, request, { responseType: 'blob' });
  }

  generateVotingResultsReport(request: CustomerReportRequest): Observable<Blob> {
    return this.http.post(`${this.base}/voting-results-report`, request, { responseType: 'blob' });
  }
}
